import type { ReviewRecord } from '@/lib/blocks/collection/records';

export const TEMPLATE_PREVIEW_REVIEWS: ReviewRecord[] = [
  {
    id: 'preview-review-1',
    title: 'Outstanding Legal Representation',
    description:
      "This is where your client testimonial will appear. Share a real review that highlights the client's experience working with you.",
    rating: 5,
    showStarRatingOnWebsite: true,
    reviewerName: 'Former Client',
    verified: true,
    createdAt: '2024-03-01',
  },
  {
    id: 'preview-review-2',
    title: 'Professional and Compassionate',
    description:
      "This is where your client testimonial will appear. Share a real review that highlights the client's experience working with you.",
    rating: 5,
    showStarRatingOnWebsite: true,
    reviewerName: 'Former Client',
    verified: true,
    createdAt: '2024-02-28',
  },
  {
    id: 'preview-review-3',
    title: 'Highly Recommend',
    description:
      "This is where your client testimonial will appear. Share a real review that highlights the client's experience working with you.",
    rating: 4,
    showStarRatingOnWebsite: true,
    reviewerName: 'Former Client',
    verified: false,
    createdAt: '2024-02-20',
  },
];
